import { FC, useRef, useState } from 'react'

import Controls from './parts/controls'
import ProgressBar from './parts/progress-bar'
import { ImageBeamedDefault } from './parts/icons'

import style from './audio-player.module.scss'

interface IAudioPlayer {
  src: string
  name: string
  materialId?: number
}

const AudioPlayer: FC<IAudioPlayer> = ({ src, name, materialId }) => {
  const [timeProgress, setTimeProgress] = useState(0)
  const [duration, setDuration] = useState(0)

  const audioRef = useRef<HTMLAudioElement>(null)
  const progressBarRef = useRef<HTMLInputElement>(null)

  const getDuration = () => {
    if (audioRef.current) {
      const audioDuration = audioRef.current.duration
      setDuration(Math.ceil(audioDuration))
    }
  }

  return (
    <div className={style.wrapper}>
      <div className={style.audioImage}>
        <ImageBeamedDefault />
      </div>
      <div className={style.inner}>
        <audio src={src} ref={audioRef} onLoadedMetadata={getDuration} />
        <p className={style.title}>{name}</p>

        <ProgressBar {...{ progressBarRef, audioRef, timeProgress, setTimeProgress, duration }} />
        <Controls
          {...{
            audioRef,
            progressBarRef,
            duration,
            setTimeProgress,
            materialId,
          }}
        />
      </div>
    </div>
  )
}

export default AudioPlayer
